import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebaa56fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-flow" }
const _hoisted_2 = { class: "t-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-flow-title" }, "比赛流程", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-flow-subtitle" }, "本次大赛分为报名&组队、初赛、复赛和决赛等四个阶级。", -1))
const _hoisted_5 = { class: "aigame-flow-area" }
const _hoisted_6 = { class: "aigame-flow-area__top" }
const _hoisted_7 = { class: "aigame-flow-area__top--title" }
const _hoisted_8 = { class: "aigame-flow-area__top--subtitle" }
const _hoisted_9 = { class: "aigame-flow-area__bd" }
const _hoisted_10 = { class: "aigame-flow-area__step" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-flow-area__line" }, null, -1))
const _hoisted_12 = { class: "aigame-flow-area__info" }
const _hoisted_13 = { class: "aigame-flow-area__info--title" }
const _hoisted_14 = { class: "aigame-flow-area__info--subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowItemUp, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['aigame-flow-area__top--item', _ctx.activeFlow.some(ind => ind === item.id) ? 'active' : ''])
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.subTitle), 1)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (i) => {
              return _createElementVNode("div", {
                key: i,
                class: _normalizeClass(['aigame-flow-area__radius', _ctx.activeFlow.some(ind => ind === i) ? 'cur' : ''])
              }, null, 2)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowItemDown, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(['aigame-flow-area__info--item', _ctx.activeFlow.some(ind => ind === item.id) ? 'active' : ''])
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.subTitle), 1)
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: "aigame-flow-area__ft",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickFlow()))
        }, "详细信息")
      ])
    ])
  ]))
}